/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class EksVolumeRestoreResult {
  /**
  * ID of the restored EKS volume.
  */
  'restoredVolumeId': string;
  /**
  * ID of the source EKS volume that was restored.
  */
  'sourceVolumeId': string;
  /**
  * Name of the source persistent volume claim (PVC) associated with the EKS volume.
  */
  'sourcePvcName': string;
  /**
  * Name of the source persistent volume (PV) associated with the EKS volume.
  */
  'sourcePvName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoredVolumeId",
      "baseName": "restoredVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceVolumeId",
      "baseName": "sourceVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourcePvcName",
      "baseName": "sourcePvcName",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourcePvName",
      "baseName": "sourcePvName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EksVolumeRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

